<template>
  <div
    ref="morePage"
    class="more"
  >
    <div
      ref="headerRef"
      class="header"
    >
      <UsdgAppBar>
        <template #left>
          <IUsdgNormalChevronLeftIcon
            class="tw:size-6! tw:text-usdg-color-icon-strong!"
            @click="goBack"
          />
        </template>
        <template #right>
          <IUsdgNormalSearchIcon
            class="tw:size-6! tw:text-usdg-color-icon-strong!"
            @click="() => $emit('click-search')"
          />
        </template>
      </UsdgAppBar>
      <div
        class="tw:mt-[14px]! tw:mx-[20px]! tw:mb-[10px]! tw:typo-title-l tw:text-usdg-color-text-title tw:font-bold"
      >
        이번 여행은<br />어디로 떠나세요?
      </div>
      <div class="controller">
        <UsdgTabs
          :model-value="currentTab"
          @update:model-value="onTabChange"
        >
          <UsdgTabList stretch>
            <UsdgTab
              value="popular"
              size="large"
            >
              인기국가
            </UsdgTab>
            <UsdgTab
              value="continent"
              size="large"
            >
              다국가
            </UsdgTab>
          </UsdgTabList>
        </UsdgTabs>
      </div>
    </div>
    <div
      class="container"
      :style="{ paddingTop: `${headerHeight}px` }"
    >
      <ProductFlagList
        :products="categorizedProducts ?? []"
        :show-more="false"
        @click-product="(product) => $emit('click-product', product)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const props = defineProps<{
  products: IProduct[] | null
}>()

defineEmits<{
  'click-product': [IProduct | undefined]
  'click-search': []
  'click-guide': []
  scroll: [boolean]
}>()

const currentTab = ref<'popular' | 'continent'>(
  route.query.tab === 'continent' ? 'continent' : 'popular'
)
const onTabChange = (value: string) => {
  currentTab.value = value as 'popular' | 'continent'
}

const headerRef = ref<HTMLElement | null>(null)
const headerHeight = ref(0)

let headerResizeObserver: ResizeObserver | null = null
onMounted(() => {
  if (!headerRef.value) return
  headerResizeObserver = new ResizeObserver(() => {
    headerHeight.value = (headerRef.value?.offsetHeight ?? 0) + 25
  })
  headerResizeObserver.observe(headerRef.value)
})

onBeforeUnmount(() => {
  headerResizeObserver?.disconnect()
})

const goBack = () => navigateTo('/')

const categorizedProducts = computed(() => {
  if (currentTab.value === 'popular') {
    return (
      props.products?.filter((product) => {
        return product.level === 'single'
      }) ?? []
    )
  } else if (currentTab.value === 'continent') {
    return (
      props.products?.filter((product) => {
        return product.level === 'multiple'
      }) ?? []
    )
  }
  return []
})
</script>

<style scoped lang="scss">
.more {
  position: relative;
  .header {
    position: fixed;
    z-index: 100;
    width: 100%;
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
  }
  & > .container {
    padding: 0 24px 24px;
  }
}
</style>
